<template>
  <div v-if="chart" :class="cls.chart" :style="containerStyle">
    <div :style="innerStyle">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, type CSSProperties, type PropType } from 'vue'
import type { StatisticCardChart as StatisticCardChartModel, StatisticCardSize } from '../types'
import { STATISTIC_CARD_CLASSES } from '../constants'

function getContainerDimensions(chart: StatisticCardChartModel, size: StatisticCardSize) {
  const isBottom = chart.placement === 'bottom'
  if (isBottom) {
    return { width: '100%', height: size === 'large' ? 76 : 60 }
  }
  return {
    width: size === 'large' ? 112 : 96,
    height: size === 'large' ? 44 : 36,
  }
}

export default defineComponent({
  name: 'StatisticCardChart',
  props: {
    chart: { type: Object as PropType<StatisticCardChartModel>, default: undefined },
    size: { type: String as PropType<StatisticCardSize>, required: true },
  },
  setup(props) {
    const cls = STATISTIC_CARD_CLASSES

    const containerStyle = computed<CSSProperties>(() => {
      if (!props.chart) return {}
      const dims = getContainerDimensions(props.chart, props.size)
      const isBottom = props.chart.placement === 'bottom'
      return {
        width: typeof dims.width === 'number' ? `${dims.width}px` : dims.width,
        minWidth: isBottom ? undefined : (typeof dims.width === 'number' ? `${dims.width}px` : dims.width),
        maxWidth: isBottom ? '100%' : (typeof dims.width === 'number' ? `${dims.width}px` : dims.width),
        height: `${dims.height}px`,
        minHeight: isBottom ? `${props.size === 'large' ? 76 : 60}px` : `${dims.height}px`,
        maxHeight: `${dims.height}px`,
        display: 'flex',
        alignItems: 'stretch',
        overflow: 'hidden',
        boxSizing: 'border-box',
        flexShrink: 0,
        position: 'relative',
      }
    })

    const innerStyle: CSSProperties = {
      width: '100%',
      height: '100%',
      minWidth: 0,
      minHeight: 0,
      overflow: 'hidden',
    }

    return {
      cls,
      containerStyle,
      innerStyle,
    }
  },
})
</script>